module.exports = __webpack_public_path__ + "static/img/54647641.svg";